import { render, staticRenderFns } from "./settlementSet.vue?vue&type=template&id=6ff9b335&scoped=true"
import script from "./settlementSet.vue?vue&type=script&lang=js"
export * from "./settlementSet.vue?vue&type=script&lang=js"
import style0 from "./settlementSet.vue?vue&type=style&index=0&id=6ff9b335&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9b335",
  null
  
)

export default component.exports